<!-- <ng-container *ngIf="isLoaded()"> -->
<sub-header [isModal]="true" [windowHash]=windowHash [includeContextHelp]="true" *ngIf="isModalWindow"></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1 pt-0" *ngIf="isModalWindow">
  <div class="container-fluid m-b-lg ">
    <div cdkTrapFocus cdkTrapFocusAutoCapture appFocusControl class="container-fluid m-b-lg" *ngIf="formGroup"
      [style.visibility]="isLoaded() ? 'visible' : 'hidden'">
      <ng-container *ngTemplateOutlet="formTemplate; context: {visibleGroups: getVisibleGroups()}"></ng-container>
    </div>
  </div>
</p-scrollPanel>
<ng-container *ngIf="!isModalWindow">
  <div class="container-fluid" *ngIf="formGroup" [style.visibility]="isLoaded() ? 'visible' : 'hidden'">
    <ng-container *ngTemplateOutlet="formTemplate; context: {visibleGroups: getVisibleGroups()}"></ng-container>
  </div>
</ng-container>
<ng-template #formTemplate let-visibleGroups="visibleGroups">
  <div class="row">
    <div [ngClass]="showValidationsPanel && formConfig?.showValidations && (errorForm?.hasFieldErrors() || errorForm?.hasUnmappedErrors())
            ? 'col-12 col-sm-8 m-t-lg'
            : 'col-12 m-t-lg'
        ">
      <form [formGroup]="formGroup" autocomplete="off" #topForm>
        <formControlError [object]="formGroup" *ngIf="!formConfig?.showValidations"></formControlError>
        <ng-container *ngIf="
            formConfig?.interfaceSetting?.display === InterfaceDisplayType.ACCORDION;
            else nonAccordionDisplay
        ">
          <p-accordion [multiple]="true" (onOpen)="openAccordion($event)" (onClose)="closeAccordion($event)">
            <ng-container *ngFor="let grp of visibleGroups; let i = index">
              <p-accordionTab [selected]="grp.group.active"
                [ngClass]="(this.emptyGroup?.get(grp.group.id) === true) ? 'd-none': undefined">
                <p-header> {{ this.formService.getGroupDescription(grp,grp.group) }} <plyca-error-counter
                    *ngIf="grp.group.displayErrorCount" [errorGroup]="grp.group.errors">
                  </plyca-error-counter>
                </p-header>
                <ng-container *ngTemplateOutlet="formGroupTpl;context:{group: grp}"></ng-container>
              </p-accordionTab>
            </ng-container>
          </p-accordion>
        </ng-container>
        <ng-container *ngIf="!isModalWindow && formConfig?.actions?.length >0">
          <div class="col-12 d-flex flex-row-reverse justify-content-between _m-t-md m-b-sm formConfig-actions">
            <button *ngFor="let action of formConfig?.actions" class="{{ action.buttonClass }}"
              (click)="executeAction(action,$event)" type="button">
              <i class="{{ action.imageClass }}"></i> {{ this.translate.get(action.buttonTextKey) | async }} </button>
          </div>
        </ng-container>
      </form>
      <ng-template #nonAccordionDisplay>
        <ng-container *ngIf="
            formConfig?.interfaceSetting?.display === InterfaceDisplayType.TAB;
            else nonTabDisplay
        ">
          <p-tabView (onChange)="activateOnlyOneGroup($event)">
            <ng-container *ngFor="let grp of visibleGroups; let i = index">
              <p-tabPanel header="{{ this.formService.getGroupDescription(grp,grp.group)}}"
                [selected]="grp.group.active" [disabled]="(this.emptyGroup?.get(grp.group.id) === true)">
                <ng-container *ngTemplateOutlet="formGroupTpl;context:{group: grp}"></ng-container>
              </p-tabPanel>
            </ng-container>
          </p-tabView>
        </ng-container>
      </ng-template>
      <ng-template #nonTabDisplay>
        <ng-container *ngIf="
            formConfig?.interfaceSetting?.display === InterfaceDisplayType.PANEL;
            else defaultDisplay">
          <ng-container *ngFor="let grp of visibleGroups; let i = index">
            <p-panel [toggleable]="true" [collapsed]="!grp.group.active"
              (onAfterToggle)="grp.group.active = !$event.collapsed" header="{{
              this.formService.getGroupDescription(grp,grp.group)
              }}" [showHeader]="!(this.emptyGroup?.get(grp.group.id) === true)"
              [styleClass]="(this.emptyGroup?.get(grp.group.id) === true) ? 'd-none': undefined">
              <ng-container *ngTemplateOutlet="formGroupTpl;context:{group: grp }"></ng-container>
            </p-panel>
          </ng-container>
        </ng-container>
      </ng-template>
      <ng-template #defaultDisplay>
        <ng-container *ngFor="let grp of visibleGroups; let i = index">
          <div class="formGroupDIV" [ngClass]="(this.emptyGroup?.get(grp.group.id) === true) ? 'd-none': undefined">
            <ng-container *ngTemplateOutlet="formGroupTpl;context:{group: grp}"></ng-container>
          </div>
        </ng-container>
      </ng-template>
    </div>
    <div
      *ngIf="showValidationsPanel && formConfig?.showValidations && (errorForm?.hasFieldErrors() || errorForm?.hasUnmappedErrors())"
      class="d-none d-sm-block col-sm-4  m-t-md">
      <div class="col-12 sticky-top rounded validations">
        <a (click)="closeValidationsPanel()"><i class="pi pi-times float-right m-t-md"></i></a>
        <plyca-validation-result [errorForm]="errorForm"></plyca-validation-result>
      </div>
    </div>
    <ng-container *ngIf="this.formConfig?.interfaceSetting?.showIndex">
      <!-- Indice del formulario-->
      <span class="index-btn position-fixed">
        <button appNoDblClick type="button" *ngIf="!showIndex" (click)="showIndex = true"
          class="btn btn-side-bar btn-sm btn-outline-primary" title="{{'Forms.ndex' | translate}}" showDelay="1000">
          <i class="fas fa-chevron-down" aria-hidden="true"></i><span class="d-none"> Índice</span>
        </button>
        <!-- <p-button label="Índice" icon="pi pi-arrow-left" (onClick)="showIndex = true" *ngIf="!showIndex"></p-button> -->
      </span>
      <p-sidebar [(visible)]="showIndex" position="right" styleClass="ui-sidebar-md" blockScroll="false">
        <form-index [fieldGroups]="this.getVisibleFieldGroups()" [renewIndex]="showIndex"
          [model]="this.formConfig.model" [functions]="formConfig?.functions"
          (selectedField)="selectedFieldFromIndex($event)" (selectedGroup)="selectedGroupFromIndex($event)">
        </form-index>
      </p-sidebar>
    </ng-container>
  </div>
</ng-template>
<ng-template #formGroupTpl let-grp="group">
  <formGroup [showHeader]="false" [formGroup]="formGroup" [formGroupConfig]="grp" [errors]="(errorForm?.fieldGroups)[i]"
    [displayErrorCount]="grp.group.displayErrorCount" (loaded)="markGroupAsLoaded(grp.group.id)"
    [lastChangesApplied]="lastChangesApplied" [updateOnChange]="this.formConfig?.interfaceSetting?.updateMode"
    (updateForm)="sendUpdateView($event)" (visibleEvt)="hideGroup($event)">
  </formGroup>
</ng-template>